module.exports = __webpack_public_path__ + "files/737e68189325e8c9743a59ad74e5400a.png";